import { Box, Flex, Heading, Text } from '@radix-ui/themes';
import React from 'react';

export type ErrorProps = React.ComponentProps<'div'>;

export function Error({ children }: ErrorProps) {
  return (
    <Flex justify="center" align="center" height="100%" flexGrow="1" width="100%">
      <Flex
        direction="column"
        align="center"
        gap="4"
        width={{
          initial: '100%',
          sm: '50rem',
          lg: '60rem',
        }}
        maxWidth={{ initial: '50rem', lg: '60rem' }}
      >
        {children}
      </Flex>
    </Flex>
  );
}

export type ErrorTitleProps = React.ComponentProps<typeof Heading>;

export function ErrorTitle({ children, ...props }: ErrorTitleProps) {
  return (
    <Heading size="8" weight="medium" align="center" {...props}>
      {children}
    </Heading>
  );
}

export type ErrorMessageProps = React.ComponentProps<typeof Text>;

export function ErrorMessage({ children, ...props }: ErrorMessageProps) {
  return (
    <Text align="center" style={{ color: 'var(--gray-11)' }} {...props}>
      {children}
    </Text>
  );
}

export type ErrorCauseProps = {
  errorMessage: string;
  errorTitle?: string | number;
};

export function ErrorCause({ errorTitle, errorMessage }: ErrorCauseProps) {
  return (
    <Box style={{ width: '100%', maxWidth: '32rem', padding: 'var(--space-6)' }}>
      {errorTitle && <Text weight="medium">{errorTitle}</Text>}
      <Text>{errorMessage}</Text>
    </Box>
  );
}

export type ErrorFooterProps = React.ComponentProps<'div'>;

export function ErrorFooter({ children }: ErrorFooterProps) {
  return (
    <Flex justify="center" gap="2">
      {children}
    </Flex>
  );
}
